import { useMiningLog } from '../hooks/useMiningLog';
import { MiningLogTable } from '../components/MiningLogTable';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export function MiningLogPage() {
  const { entries, total, loading, error, refresh, loadMore, hasMore } = useMiningLog();

  if (loading && entries.length === 0) {
    return (
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Mining History</h2>
        <Skeleton className="h-64" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Mining History</h2>
        <p className="text-destructive">{error}</p>
        <Button onClick={refresh} variant="outline">
          Retry
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">
          Mining History{' '}
          {total > 0 && <span className="text-muted-foreground text-base">({total})</span>}
        </h2>
        <Button onClick={refresh} variant="outline" size="sm">
          Refresh
        </Button>
      </div>

      <MiningLogTable entries={entries} />

      {hasMore && (
        <div className="flex justify-center pt-4">
          <Button onClick={loadMore} variant="outline" disabled={loading}>
            {loading ? 'Loading...' : 'Load More'}
          </Button>
        </div>
      )}
    </div>
  );
}
